import { useTranslation } from 'react-i18next'
import { Typography } from 'antd'

import { Page } from '../structure'

import { LinkWithPicture } from '../components/common/'
import { LoginOrRegister } from '../components/Login/LoginOrRegister'
import { HowItWorks } from '../components/Login'
const { Title } = Typography

const Login = () => {
  const { t } = useTranslation()

  return (
    <Page className="login" title="Login">
      <Title>{t('Login.PublishYourText')}</Title>
      <LoginOrRegister />
      <LinkWithPicture text={t('Login.WhatsNext')} content={<HowItWorks />} />
    </Page>
  )
}

export default Login
